import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface PaginationProps {
    currentPage: number;
    totalPages: number;
    onPageChange: (page: number) => void;
    className?: string;
}

export const Pagination: React.FC<PaginationProps> = ({
    currentPage,
    totalPages,
    onPageChange,
    className = '',
}) => {
    const getPageNumbers = () => {
        const pages: (number | string)[] = [];
        const maxVisiblePages = 5;

        if (totalPages <= maxVisiblePages) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            if (currentPage <= 3) {
                pages.push(1, 2, 3, 4, '...', totalPages);
            } else if (currentPage >= totalPages - 2) {
                pages.push(1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
            } else {
                pages.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
            }
        }
        return pages;
    };

    // if (totalPages <= 1) return null;

    return (
        <div className={`flex items-center gap-4 md:gap-6 justify-between ${className}`}>
            <span className="text-base font-bold text-[#181717]">
                Page {currentPage} of {totalPages}
            </span>
            <div className="flex items-center gap-4">
                <div className='flex gap-1 items-center'>               
                {getPageNumbers().map((page, index) => (
                    <React.Fragment key={index}>
                        {page === '...' ? (
                            <span className="text-gray-400 px-2">...</span>
                        ) : (
                            <button
                                onClick={() => onPageChange(page as number)}
                                className={`w-6 h-6 flex items-center justify-center rounded-md text-sm font-medium transition-colors border
                  ${currentPage === page
                                        ? 'bg-white border-wine-100 text-wine-100 ring-1 ring-wine-100'
                                        : 'text-gray-500 hover:bg-gray-50 border-transparent'
                                    }`}
                            >
                                {page}
                            </button>
                        )}
                    </React.Fragment>
                ))}
 </div>
                <div className="flex bg-[#681628] rounded overflow-hidden">
                    <button
                        onClick={() => onPageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                        className="w-9 h-9 flex items-center justify-center rounded-md bg-[#951F39] text-white disabled:opacity-50 disabled:cursor-not-allowed hover:bg-[#50111f] transition-colors"
                    >
                        <ChevronLeft className="w-4 h-4" />
                    </button>
                    <button
                        onClick={() => onPageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        className="w-9 h-9 flex items-center justify-center rounded-md bg-[#951F39] text-white disabled:opacity-50 disabled:cursor-not-allowed hover:bg-[#50111f] transition-colors"
                    >
                        <ChevronRight className="w-4 h-4" />
                    </button>
                </div>
            </div>
        </div>
    );
};
